import clsx from 'clsx'
import type { ReactNode } from 'react'
import { CATEGORY_COLORS } from './nudgeCategoryStyles'
import type { LibraryNudge } from './libraryNudge'

type Props = {
  nudge: LibraryNudge
  onClick: () => void
  /** e.g. checkbox for bulk select — clicks stop propagation */
  leading?: ReactNode
}

export function NudgeCard({ nudge, onClick, leading }: Props) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="text-left bg-warm-card border border-warm-border hover:border-brand-teal/35 rounded-2xl p-5 transition-all hover:-translate-y-0.5 shadow-card hover:shadow-glow-teal group w-full"
    >
      <div className="flex items-start justify-between gap-2 mb-2">
        <div className="flex items-center gap-2 min-w-0">
          {leading ? (
            <span
              className="shrink-0"
              onClick={(e) => e.stopPropagation()}
              onKeyDown={(e) => e.stopPropagation()}
            >
              {leading}
            </span>
          ) : null}
          <span
            className={clsx(
              'text-xs font-medium px-2.5 py-1 rounded-full border capitalize',
              CATEGORY_COLORS[nudge.category] ?? 'bg-warm-inset text-ink-muted border-warm-border'
            )}
          >
            {nudge.category}
          </span>
        </div>
        <span className="text-xs text-ink-soft shrink-0">{Math.round(nudge.effectiveness_score * 100)}% effective</span>
      </div>
      <h3 className="font-semibold text-ink text-sm mb-1 group-hover:text-brand-teal transition-colors">{nudge.title}</h3>
      <p className="text-xs text-ink-muted line-clamp-2 leading-relaxed">{nudge.body}</p>
    </button>
  )
}
